<template>
  <div id="container" :class="{'newYear':isBGLogin}">
    <div id="LoginBox" v-if='!isGoogle' v-loading="loading">
      <div class="login_logo">
        <a href="/" class="logo"></a>
        <h1 class="line_h1">{{$t('base.welcome')}}</h1>
      </div>
      <div class="login_tab">
        <div :class="{'on':ruleForm.Type=='1'}" @click="ruleForm.Type='1'">{{$t('base.phoneNumber')}}</div>
        <div :class="{'on':ruleForm.Type=='0'}" @click="ruleForm.Type='0'">{{$t('base.email')}}</div>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item" prop="Account">
          <!-- 国籍 -->
          <div class="locationPhoneBox login_location" v-if="ruleForm.Type=='1'">
            <div class="countries" v-if="location.MemberSource!=''">
              <img :src="location.LocationIcon" alt="">
            </div>
            <el-select class="login_ipt" :class="location.MemberSource!=''?'nolocation':''" placeholder="" v-model="location.MemberSource" popper-class='location' @change='changeLocation'>
              <el-option class="locationelOption" :label="item.EnName" :value="item.Code" v-for="(item,index) in locationOption" :key='index'>
                <div class="locationOption">
                  <img :src="item.IconUrl">
                  <span>{{item.EnName}}</span>
                </div>
              </el-option>
            </el-select>
            <div class="nationCode">
              {{location.AreaCode}}
            </div>
          </div>
          <!-- 手机号和邮箱 -->
          <el-input class="login_ipt first_login_ipt" :class="{'email':ruleForm.Type=='1'}" v-model="ruleForm.Account" :placeholder="ruleForm.Type=='1'?$t('base.phoneNumber'):$t('base.email')" autocomplete="off" @input='emailInput'></el-input>
          <!-- <el-input class="login_ipt first_login_ipt" v-model="ruleForm.Account" placeholder="Email" @input='emailInput' v-if="ruleForm.Type=='0'"></el-input> -->
        </el-form-item>
        <el-form-item class="login_form_item" prop="Password">
          <el-input class="login_ipt" :type="flagType" v-model="ruleForm.Password" :placeholder="$t('base.password')" @input="search" autocomplete="off">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" v-show="ifshow" @click="getFlag()" />
          </el-input>
        </el-form-item>
        <div class="forgot">
          <span class="text_blue" @click="goto('ruleForm')">{{$t('symbol.forgotPwd')}}</span>
        </div>
        <div class="googleInfoBtn">
          <el-button class="text_btn" :disabled="disabled" type="primary" @click="submitForm('ruleForm')">{{$t('base.logIn')}}</el-button>
          <google-identity @getData="getGoogleData"/>
        </div>
      </el-form>
      <div class="terms_checked">
        <!-- <el-checkbox v-model="checked"></el-checkbox> -->
        <el-checkbox v-model="checkbox " :label="1">{{radioNumber}}</el-checkbox>
        <div>
          <i18n path="base.agreeTo" tag="p" >
          <router-link class="text_blue" :to="{path:'/terms/privacy?type=2'}" target="_blank">{{$t('base.service')}}</router-link>
          <router-link class="text_blue" :to="{path:'/terms/privacy?type=1'}" target="_blank">{{$t('base.privacy')}}</router-link>
          </i18n>
          <!-- {{$t('base.agreeTo')}} <router-link class="text_blue" :to="{path:'/terms/privacy?type=2'}" target="_blank">{{$t('base.service')}}</router-link> {{$t('base.and')}} 
          <router-link class="text_blue" :to="{path:'/terms/privacy?type=1'}" target="_blank">{{$t('base.privacy')}}</router-link> -->
        </div>
      </div>
      <div class="account_box">
        {{$t('symbol.noAccount')}} <router-link class="text_blue" :to="{path:'/register'}">{{$t('base.signUp')}}</router-link>
      </div>
    </div>
    <!-- google绑定 -->
    <google-binding v-if="isGoogle&&gdata.type==1&&env!='production'" :gdata='gdata' :locationOption='locationOption' />
    <!-- google注册 -->
    <google-register v-if="isGoogle&&gdata.type==0&&env!='production'" :gdata='gdata' :locationOption='locationOption' />
  </div>
</template>
<script>
import GoogleIdentity from '@/components/google-identity' //  google登录
import GoogleBinding from '@/components/googlebinding' //  google绑定
import GoogleRegister from '@/components/googleregister' //  google绑定
import { CensoredEmail, getUser,countries } from "@/api/public";
export default {
  name: 'index',
  components: { GoogleIdentity, GoogleBinding, GoogleRegister },
  data() {
    /**
     * 用户输入验证函数
     * @param {Object} rule 验证规则对象
     * @param {string} value 需要验证的值
     * @param {Function} callback 回调函数
     * @description 验证用户输入的邮箱或手机号格式是否正确
     * - Type为0时验证邮箱格式
     * - Type为1时验证手机号格式
     * - 验证通过调用callback()
     * - 验证失败调用callback(new Error())返回相应错误信息
     */
    var userValidate = (rule, value, callback) => {
      if (value === '') {
        if (this.ruleForm.Type == '1') {
          callback(new Error(this.$t('rules.invalidPhone')));
        }
        callback(new Error(this.$t('rules.emailRule')));
      } else if (value != '') {
        if (this.ruleForm.Type == '0') {
          let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          if (reg.test(value)) {
            callback();
          } else {
            callback(new Error(this.$t('rules.emailRule')));
          }

        }
        callback();
      } else if (this.smsMsg) {
        callback(new Error(this.smsMsg));
      } else {
        callback();
      }
    };
    var passValidate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('rules.emailPwdIncorrect')));
      } else if (this.psMsg) {
        callback(new Error(this.psMsg));
      } else {
        callback();
      }
    };
    return {
      env: process.env.NODE_ENV,
      gdata: '',
      isGoogle: false,
      isBGLogin: process.env.VUE_APP_LOGIN,
      flagType: 'password',
      flag: false,
      loading: false,
      psMsg: '',
      smsMsg: '',
      disabled: false,
      // checked:false,
      radioNumber: '',
      checkbox: false,
      ifshow: false,
      locationOption: '',
      location: {
        MemberSource: '',
        LocationIcon: '',
        LocationName: '',
        AreaCode: ''
      },
      ruleForm: {
        Account: '', //邮箱或手机
        Password: '', //密码
        Type: '1', //登录类型 0邮箱 1手机号
        AreaCode: '' //手机区号
      },
      rules: {
        Account: [
          { validator: userValidate, trigger: 'blur' },
          //{ type: 'email', message: 'Enter the email address like this: name@email.com', trigger: 'blur' },
        ],
        Password: [
          { validator: passValidate }
        ]
      },
    }
  },
  created() {
    this.getNationIcons()
  },
  mounted() {
    let that = this
    window.addEventListener('keydown', function(e) {
      if (e.keyCode === 13) {
        that.submitForm('ruleForm')
      }
    })
    //console.log(this.$interface.SignIn)
  },
  beforeDestroy() {
    window.removeEventListener('message', function(e) {});
  },
  methods: {
    /**
     * 处理 Google 账号登录逻辑
     * @param {Object} obj - Google 账号绑定信息对象,包含用户基本信息
     * @param {Object} gobj - Google 登录返回的原始数据对象
     * @description 如果 Google 账号已绑定则直接登录,未绑定则提示用户选择绑定现有账号或注册新账号
     * - 已绑定: 调用 getUser 接口进行登录
     * - 未绑定: 弹出确认框,用户可选择:
     *   - 确认: 绑定已有账号(type=1)
     *   - 取消: 注册新账号(type=0)
     */
    getGoogleData(obj, gobj) {
      let that = this
      if (obj) {
        // google账号已绑定，直接登录
        that.loading = true;
        that.disabled = true;
        const googleDate = {
          AreaCode: obj.AreaCode,
          ChineseToken: obj.ChineseToken,
          EMail: obj.EMail,
          HeadPortrait: obj.HeadPortrait,
          Id: obj.Id,
          IsSeller: obj.IsSeller,
          Language: obj.Language,
          MappingUserId: obj.MappingUserId,
          NickName: obj.NickName,
          Status: obj.Status,
          TelPhone: obj.TelPhone
        }
        getUser(googleDate)
        setTimeout(function() {
          that.loading = false;
          that.disabled = false;
        }, 1000)
      } else {
        // google账号，未绑定 ，跳转
        that.$confirm(that.$t('base.isgoogleid'), '', {
          confirmButtonText: that.$t('base.yes'),
          cancelButtonText: that.$t('base.no'),
          lockScroll: false,
          closeOnClickModal:false,
          closeOnPressEscape:false,
          distinguishCancelAndClose:true
        }).then(() => {
          //绑定账号
          that.isGoogle = true
          gobj.type = 1
          that.gdata = gobj
        }).catch((action) => {
          if(action=='cancel'){
            //注册账号
            that.isGoogle = true
            gobj.type = 0
            that.gdata = gobj
          }
        });
      }
    },
    // 修改国家
    /**
     * 更新用户选择的地区信息
     * @param {string} e - 地区代码
     * @description 根据选择的地区代码更新相关地区信息,包括:
     * - 会员来源(MemberSource)
     * - 地区图标(LocationIcon) 
     * - 地区英文名(LocationName)
     * - 区号(AreaCode)
     * - 表单区号(ruleForm.AreaCode)
     */
    changeLocation(e) {
      let that = this
      that.locationOption.map(res => {
        if (res.Code == e) {
          that.location.MemberSource = res.Code //
          that.location.LocationIcon = res.IconUrl
          that.location.LocationName = res.EnName
          that.location.AreaCode = res.NationCode
          that.ruleForm.AreaCode = res.NationCode
        }
      })
      //console.log(that.ruleForm)
    },
    //获取全部国家图标地址
    /**
     * 获取国家/地区图标列表并设置默认选中项
     * 通过接口获取所有国家/地区的图标信息,并将第一个选项作为默认值
     * 设置地区相关信息:来源代码、图标URL、英文名称、区号等
     * @returns {void}
     */
    getNationIcons() {
      let that = this
      this.$get(this.$interface.GetAllNationIcons, '').then(res => {
        if (res.Result != 0) {
          that.locationOption = countries(res.Data)
          that.location.MemberSource = res.Data[0].Code //
          that.location.LocationIcon = res.Data[0].IconUrl
          that.location.LocationName = res.Data[0].EnName
          that.location.AreaCode = res.Data[0].NationCode
          that.ruleForm.AreaCode = res.Data[0].NationCode
        }
      })
    },
    //是否显示查看密码的图标
    /**
     * 监听密码输入框变化，控制密码可见性图标的显示状态
     * @description 当密码长度大于0时显示图标，否则隐藏图标
     * @private
     */
    search() {
      if (this.ruleForm.Password.length > 0) {
        this.ifshow = true
      } else {
        this.ifshow = false
      }
    },
    //密码切换状态
    /**
     * 切换密码显示/隐藏状态
     * @description 通过点击切换密码框的显示类型,在明文(text)和密文(password)之间转换
     * @returns {void}
     */
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
      //console.log(this.flag,this.flagType)
    },
    // 删除email清空密码
    /**
     * 监听邮箱输入框变化
     * 当账号输入框为空时,清空密码输入框
     * @watch emailInput
     */
    emailInput() {
      if (this.ruleForm.Account.length < 1) {
        this.ruleForm.Password = ''
      }
    },
    // 有邮箱跳转忘记密码
    /**
     * 导航到忘记密码页面
     * @param {string} formName - 表单名称
     * @description 根据用户类型和账号信息跳转到忘记密码页面,
     * 如果用户类型为'1',则额外携带来源信息
     */
    goto(formName) {
      let that = this;
      let query = { account: that.ruleForm.Account, type: that.ruleForm.Type }
      if (that.ruleForm.Type == '1') {
        query.source = that.location.MemberSource
      }
      this.$router.push({
        path: '/forgot',
        query: query
      })
      // that.smsMsg = ""
      // that.$refs[formName].validateField("email", (val) => {
      //   if (val == "") {
      //     this.$router.push({
      //       path: '/forgot',
      //       query: {
      //         email: that.ruleForm.email
      //       }
      //     })
      //   }
      // })
    },
    // 登入
    submitForm(formName) {
      let that = this;
      that.psMsg = "", that.smsMsg = ""
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = that.ruleForm
          if (that.ruleForm.Type != '1') {
            data.AreaCode = '+86'
          }
          if (this.checkbox == false) {
            this.$confirm(`<div style="padding: 0 24px;">` + that.$t('alert.toProceed') + ` <a href="#/terms/privacy?type=2"  target="_blank" class="text_blue">` + that.$t('base.service') + `</a> ` + that.$t('base.and') + ` <a href="#/terms/privacy?type=1"  target="_blank" class="text_blue">` + that.$t('base.privacy') + `</a>.</div>`, that.$t('base.notice'), {
                // showConfirmButton: true ,
                customClass: "NoticeBox",
                dangerouslyUseHTMLString: true,
                confirmButtonText: that.$t('base.agree'),
                cancelButtonText: that.$t('base.cancel'),
              }).then(() => {
                this.checkbox = true;
                this.submitForm('ruleForm');
              })
              .catch(() => {

              });
          } else {
            this.disabled = true;
            that.loading = true;
            this.$post(this.$interface.SignIn, data).then(res => {
              //console.log(res.Data,'res.Data')
              if (res.Result != 0) {
                // this.$message({
                //   type: 'success',
                //   duration: 1000,
                //   message: 'Login successful!'
                // });
                if (res.Data.EMail || res.Data.Email) {
                  res.Data.Email = CensoredEmail(res.Data.EMail || res.Data.Email)
                }
                getUser(res.Data)
                setTimeout(function() {
                  that.loading = false;
                  that.disabled = false;
                }, 1000)
              } else {
                if (res.Msg.toLowerCase().indexOf('password') != -1) {
                  that.psMsg = res.Msg
                  that.$refs[formName].validateField("Password");
                } else {
                  that.smsMsg = res.Msg
                  that.$refs[formName].validateField("Account");
                }
                this.$message({
                  type: 'error',
                  duration: 2000,
                  message: res.Msg
                });
                that.loading = false;
                //that.$refs[formName].validateField("email");
                that.disabled = false;
              }
            }).catch(error => {
              that.loading = false;
              that.disabled = false;
            })
          }
        }
      });
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/login.css";

/* /deep/.login_ipt .el-input__suffix{
  margin: 14px 10px 0 0;
} */
/deep/ .el-checkbox__inner {
  border-color: #a0a0a0;
}

</style>



// WEBPACK FOOTER //
// src/pages/shared/login.vue